// extracted by mini-css-extract-plugin
module.exports = {"root":"_3eah5","SeparateLinesMenuButtonNSkin":"_3NK1k","separateLinesMenuButtonNSkin":"_3NK1k","linkElement":"_2Gq59","gapper":"_1v1ot","borderWrapper":"_6Kp6R","label":"_2hpSQ"};